const initialStateTeacherModuleResults = {
  loading: false,
  error: null,
  result: [
    {
      courseModuleId: null,
      name: null,
      description: null,
      approvalLimit: null,
      url: null,
      students: [
        {
          studentId: null,
          name: null,
          className: null,
          status: null,
          statusNumber: null,
          score: null,
          hasPassed: false,
          isDone: false,
          isCompleted: false,
          approvalLimit: null,
          nbrOfAttempts: null,
          finalExamEnabled: false,
          activated: ""
        }
      ]
    }
  ],
  statusCode: null
};

export function teacherModuleResultsReducer(
  state = initialStateTeacherModuleResults,
  action
) {
  switch (action.type) {
    case "FETCH_TEACHER_MODULE_RESULTS_BEGIN": {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case "FETCH_TEACHER_MODULE_RESULTS_SUCCESS": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case "FETCH_TEACHER_MODULE_RESULTS_REJECTED": {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }
    case "FETCH_TEACHER_FINALEXAM_RESULTS_BEGIN": {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case "FETCH_TEACHER_FINALEXAM_RESULTS_SUCCESS": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case "FETCH_TEACHER_FINALEXAM_RESULTS_REJECTED": {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }
    default:
      return state;
  }
}
